const crossOriginPageUrl = process.env.REACT_APP_AUTHHINTS_URL;
//const crossOriginPageUrl = process.env.nvidiaauthhints;

export function readHint() {
  return new Promise((resolve) => {
    const { origin: targetOrigin } = new URL(crossOriginPageUrl);
    const iframe = document.createElement("iframe");
    iframe.hidden = true;
    iframe.src = crossOriginPageUrl;
    function responseHandler(event) {
      if (event.origin === targetOrigin) {
        iframe.parentNode.removeChild(iframe);
        return resolve(event.data);
      }
    }
    // Listener to capture the response from the iframe
    window.addEventListener("message", responseHandler, { once: true });

    iframe.onload = () => {
      iframe.contentWindow.postMessage({ type: "read" }, targetOrigin);
    };
    // Appending the iframe triggers the request
    document.body.appendChild(iframe);
  });
}

export function writeHint(login_hint, idp_id, timestamp, sub) {
  console.log("[writeHint] Started");

  return new Promise((resolve) => {
    const { origin: targetOrigin } = new URL(crossOriginPageUrl);

    console.log("[writeHint] targetOrigin:", targetOrigin);
    console.log("[writeHint] crossOriginPageUrl:", crossOriginPageUrl);

    const iframeDOC = document.getElementById("NPN_Iframe");

    if (iframeDOC) {
      console.log("[writeHint] Existing iframe found. Removing old iframe.");
      document.body.removeChild(iframeDOC);
    }

    const iframe = document.createElement("iframe");
    iframe.hidden = true;
    iframe.src = crossOriginPageUrl;
    iframe.id = "NPN_Iframe";

    console.log("[writeHint] New iframe created");

    // Convert timestamp to ISO format with milliseconds
    timestamp = new Date(timestamp * 1000).toISOString();

    console.log("[writeHint] Converted timestamp:", timestamp);

    iframe.onload = () => {
      const message = { type: 'write', login_hint, idp_id, timestamp, sub };
      iframe.contentWindow.postMessage(message, targetOrigin);

      // wait briefly before resolving
      setTimeout(() => {
        console.log("[writeHint] Promise resolved");
        resolve(true);
      }, 500);
    };

    iframe.onerror = (error) => {
      console.error("[writeHint] iframe failed to load", error);
      resolve(false);
    };

    console.log("[writeHint] Appending iframe to body");

    document.body.appendChild(iframe);
  });
}

